import { useMemo } from 'react';
import {
  BOOKINGS_PER_TRAIN_TAB,
  BOOKINGS_WITH_MINORS_TAB,
  BOOKING_DETAILS_TAB,
  ON_HOLD_BOOKINGS_TAB,
  PNR_TAB,
  BOOKINGS_WITH_SPECIAL_ASSISTANCE
} from './BookingSearch';

export const useDefaultTab = (location) =>
  useMemo(() => {
    if (!location.hash) {
      return PNR_TAB;
    }

    const tab = location.hash.substring(1);

    if (
      tab !== PNR_TAB &&
      tab !== BOOKING_DETAILS_TAB &&
      tab !== ON_HOLD_BOOKINGS_TAB &&
      tab !== BOOKINGS_WITH_MINORS_TAB &&
      tab !== BOOKINGS_PER_TRAIN_TAB &&
      tab !== BOOKINGS_WITH_SPECIAL_ASSISTANCE
    ) {
      return PNR_TAB;
    }

    return tab;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
